const mapDataSource = (dataSourceProp: any) => {
    const computedProp: any = {};
    for (const [name, prop] of Object.entries(dataSourceProp)) {
        computedProp[name] = {
            get() {
                const defaultValue = prop.default;
                let returnValue = (this[prop.carrier] && this[prop.carrier][name]);
                return returnValue || (defaultValue || '');
            },
            set(newValue: any) {
                const option = prop.getOption(newValue);
                this.set_partData(option);
            }
        }
    }
    return computedProp;
};
export { mapDataSource };